module.exports = __webpack_public_path__ + "static/media/green-tick.d630f642.svg";